import React, { Component } from "react";
import { Row, Col, Modal } from "react-bootstrap";
import api from "../../api";
import AdminLayout from "../../components/adminLayout";
import Loader from "../../components/Loader";
import { resp } from "../../services/responseHandler";

export default class Engage extends Component {
  constructor(props) {
    super(props);
    // Recieving Params
    const query = new URLSearchParams(this.props.location.search);
    const rec_fb_page_id = query.get("fb_page_id");
    const rec_biz_id = query.get("biz_id");
    this.state = {
      modalShow: false,
      biz_id: rec_biz_id,
      fb_page_id: rec_fb_page_id,
      bots: [],
      available_bots: [],
      loading: true,
    };
  }

  componentWillMount() {
    this.loadBizData = this.loadBizData.bind(this);
    this.deleteBiz = this.deleteBiz.bind(this);
    this.loadBizData(this.state.biz_id);
    this.getAvailableBots();
  }

  showModal = () => {
    this.setState({ modalShow: true });
  };
  hideModal = () => {
    this.setState({ modalShow: false });
  };

  async getAvailableBots() {
    var query = { metric: "available_bots" };
    await api.postService("/default_metrics/get", query).then(
      (res) => {
        console.log("Response:", res);
        let data = res.data.data;
        this.setState({ available_bots: data.value });
        this.setState({ loading: false });
      },
      (error) => {
        console.log("error", error);
        this.setState({ loading: false });
      }
    );
  }

  async deleteBiz() {   
    this.setState({ loading: true });
    var query = {};
    await api.deleteService(`/business/${this.state.biz_id}`, query).then(
      (res) => {
        console.log("Response:", res);
        this.setState({ loading: false });
        resp.ResponseHandler(res,"navToPage",'/dashboard');
      },
      (error) => {
        console.log("error", error);
        this.setState({ loading: false });
        resp.ErrorHandler(error);
        
      }
    );
  }

  

  loadBizData = async (biz_id) => {
    api.getService(`/bots/${biz_id}`).then(
      (res) => {
        console.log("Business:", res);
        let data = res.data.data;
        this.setState({ biz: data, bots: data });
      },
      (error) => {
        console.log("error", error);
      }
    );
  };

  installBot(bot) {
    this.setState({ loading: true });
    var payload = bot;
    payload["biz_id"] = this.state.biz_id;
    api.postService(`/bot`, payload).then(
      (result) => {
        console.log("resp", result);
        this.setState({ loading: false });
        resp.ResponseHandler(result);
      },
      (error) => {
        console.log("error", error);
        this.setState({ loading: false });
        resp.ErrorHandler(error);
      }
    );
  }

  viewBot(link, bot_id) {
    this.props.history.push({
      pathname: link,
      search: `?biz_id=${this.state.biz_id}&bot_id=${bot_id}`,
    });
  }

  chatHistory() {
    this.props.history.push({
      pathname: "/chat_history",
      search: `?fb_page_id=${this.state.fb_page_id}&biz_id=${this.state.biz_id}`,
    });
  }

  goBack() {}

  render() {
    return (
      <AdminLayout>
        {this.state.loading ? <Loader /> : ""}
        <div className="row mb-5">
          <div className="col">
            <div className="buttons float-left">
              <button className="btn text-primary" onClick={this.props.history.goBack}><i class="fa fa-chevron-circle-left" aria-hidden="true"></i> Go back</button>
            </div>
            <div className="buttons float-right">
              <button
                type="button"
                className="btn btn-primary mr-3"
                onClick={this.showModal}
              >
                Add Bot
              </button>

              <button
                type="button"
                className="btn btn-danger mr-3"
                onClick={this.deleteBiz}
              >
                Delete Page
              </button>
            </div>
          </div>
        </div>
        <div className="row">
          {this.state.bots.map((bot, index) => (
            <div className="col-md-4 stretch-card grid-margin">
              <div className="card shadow-sm card-img-holder">
                <div className="card-body mx-auto">
                  <img src={bot?.image_url} className="img-fluid img-bot" />
                  <button
                    type="button"
                    class="btn btn-link"
                    onClick={() => this.viewBot(bot.link, bot.id)}
                  >
                    {bot?.title}
                  </button>
                </div>
                {/* <div className="card-footer text-muted">
                  <div className="float-right">
                    <label className="switch">
                      <input
                        type="checkbox"
                        name={index}
                        checked={bot.enabled}
                        onChange={this.changeBotStatus}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div> */}
              </div>
            </div>
          ))}
        </div>
        <div className="row">
        <div className="col-md-4 stretch-card grid-margin">
              <div className="card shadow-sm card-img-holder">
                <div className="card-body mx-auto">
                  <button
                    type="button"
                    class="btn btn-link"
                    onClick={() => this.chatHistory()}
                  >
                    Un-resolved Messages
                  </button>
                </div>
              </div>
            </div>

          </div>

        <Modal show={this.state.modalShow} onHide={this.hideModal} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>Available Bots</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              {this.state.available_bots.map((bot, index) => (
                <Col xs={6} md={4} className="h-100">
                  <div class="card text-center mb-3">
                    <div class="card-body">
                      <img
                        class="card-img-top mx-auto d-block w-25 mb-3"
                        src={bot?.image_url}
                      />
                      <h5 class="card-title">{bot?.title}</h5>
                      <p class="card-text">{bot?.desc}</p>

                      <button
                        className="btn btn-primary"
                        type="button"
                        onClick={() => this.installBot(bot)}
                      >
                        {" "}
                        Install
                      </button>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </Modal.Body>
        </Modal>
      </AdminLayout>
    );
  }
}
